
import commonLayoutMixin from '~/layouts/commonLayoutMixin';

export default {
  name: 'SupportLayout',
  mixins: [commonLayoutMixin],
  // Note: The head() function is inherited from the mixin,
};
